var React = require('react');
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var PropTypes = require('prop-types');
var cookie = require('react-cookie');
var AuthActions = require('../../../modules/auth/actions/auth-login');
var Actions = require('../../../modules/auth/actions/auth-current-user');
var authRefreshTokenActions = require('../../../modules/auth/actions/auth-refresh-token');

var requireAuth = function(Component) {
    var AuthenticatedComponent = createReactClass({

      componentDidMount: function(){
          var refreshToken = cookie.load('mgih_at_refresh');

          if(!refreshToken){
              this.checkAndRedirect();
          }
      },

      componentDidUpdate: function(prevProps) {
          if(this.props.auth !== prevProps.auth){
              this.checkAndRedirect();
          }
      },

      checkAndRedirect: function() {
        if(!this.props.auth.isFetching){
            if(this.props.auth.token){
                if(Object.keys(this.props.auth.user).length > 0){
                    if(this.props.location.pathname.startsWith('/admin/') && !this.props.auth.isAdmin){
                        this.context.router.push('/');
                    }
                }
            }else{
                this.props.setLoginRedirectUrl(this.props.location.pathname);
                this.context.router.replace('/login');
            }
        }
      },

      render: function() {
         return this.props.auth.token && Object.keys(this.props.profile.data).length !== 0 && (this.props.location.pathname.startsWith('/admin/') ? this.props.auth.isAdmin : true) ? <Component {...this.props} /> : null;
      }
    });

  AuthenticatedComponent.propTypes = {
    loginSuccess: PropTypes.func.isRequired,
    fetchCurrentUserIfNeeded: PropTypes.func.isRequired,
    // push: PropTypes.func.isRequired,
    auth: PropTypes.object
  };

  AuthenticatedComponent.contextTypes = {
    router: PropTypes.object.isRequired
  };

  var mapStateToProps = function(state){
      return {
        auth: state.auth,
        profile: state.profile
      };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, authRefreshTokenActions, AuthActions, Actions), dispatch);
  }

  return ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);
};

module.exports = requireAuth;



// WEBPACK FOOTER //
// ./src/common/routes/auth/components/requireAuth.jsx